export const ARROW_LEFT_KEY_CODE: number = 39;
export const ARROW_RIGHT_KEY_CODE: number = 37;
